module.exports = __webpack_public_path__ + "static/media/playf2.da87c557.svg";